module.exports = __webpack_public_path__ + "img/home_testimonial1.ece5608.png";